<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <!-- <h3>mcq new</h3> -->
        <!-- props: -- selcrs- {{ sel_crs }} <br />
      chap-{{ chapter }} <br />
      typ- {{ quiztype }} <br />
  
      
      learners:{{learners.display_name}} -->

        <span class="slide">*NOTE:Question And Option Image File size Should be less than {{ imagesize_new }} KB And It
            Should be in <span v-for="(img, index) in imagetype_new" :key="index"> {{ img.imagetype }}
            </span>Format!!!</span>
        <v-row dense justify="center"></v-row>
        <v-card class="box">
            <v-row justify="center">
                <span v-if="imageSizeFlag">
                    <v-col cols="12" xs="12" sm="12">
                        <p class="slide">
                            Question File size should be less than {{ imagesize_new }}KB!
                        </p>
                    </v-col>
                </span>
                <span v-if="imageTypeFlag">
                    <v-col cols="12" xs="12" sm="12">
                        <p class="slide">
                            Question File Should Be In -
                            <span v-for="(img, index) in imagetype_new" :key="index">
                                {{ img.imagetype }}
                            </span>
                            Format!!!
                        </p>
                    </v-col>
                </span>
            </v-row>
            <div>
                <!-- <v-col cols="12" sm="1" md="1"> -->
                <!-- <v-checkbox color="#0F2027" v-model="isapprove" class="mx-2" label="Is Approve"></v-checkbox> -->
                <v-btn icon @click="showEditor" style="float: right;"> <v-icon title="CK Text Editor"
                        color="black">mdi-file-edit-outline</v-icon></v-btn>
                <!-- </v-col> -->
            </div>
            <v-row dense>
                <!-- <v-col cols="12" md="2" sm="2"></v-col> -->
                <v-col cols="12" sm="1" md="1">
                    <v-text-field color="#0F2027" label="Marks" v-model.trim="weightage" type="number"
                        required></v-text-field>
                </v-col>
                <v-col cols="12" sm="1" md="1"></v-col>

                <v-col cols="12" sm="5" md="5">
                    <!-- <ckeditor v-model="question" :config="editorConfig"></ckeditor> -->
                    <v-textarea label="Question Title" auto-grow v-model="question" outlined rows="3"></v-textarea>
                </v-col>
                <v-col cols="12" sm="1" md="1"></v-col>

                <!-- size--{{size_flag}}  --  Ext--{{ext_flag}} --- Valid--{{image_valid}} -->

                <v-col cols="12" sm="3" md="3">
                    <v-file-input v-model="qfile" id="file" prepend-icon="mdi-attachment" label="Choose File" show-size
                        accept="image/*" variant="solo" @change="validateFile()"></v-file-input>
                    <!-- name="doc" -->
                    <!-- @change="validateFile()"    -->
                </v-col>
            </v-row>
        </v-card>
        <!-- <v-card class="box">
      <v-row justify="center">
        <span v-if="imageSizeFlag1">
          <v-col cols="12" md="12" sm="12">
            <p class="slide">
              Option1 File size should be less than {{ imagesize_new }}KB!
            </p>
          </v-col>
        </span>
        <span v-if="imageTypeFlag1">
          <v-col cols="12" md="12" sm="12">
            <p class="slide">
              Option1 File in
              <span v-for="(img, index) in imagetype_new" :key="index">
                {{ img.imagetype }}
              </span>
              Format!!!
            </p>
          </v-col>
        </span>
      </v-row>
      <v-row>
        <v-col cols="12" sm="2" md="2"> Option 1 </v-col>
        <v-col cols="12" sm="7" md="7">
          <ckeditor v-model="option_01" :config="editorConfig"></ckeditor>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-row>
            <v-col cols="12">
              <v-file-input
                v-model="optfile1"
                prepend-icon="mdi-attachment"
                label="Choose File"
                id="file1"
                show-size
                name="doc"
                @change="validateFile1()"
              ></v-file-input>
            </v-col>
            <v-col cols="12">
              <input
                type="radio"
                class="radiospace"
                id="a"
                value="a"
                v-model="iscorrect_01"
                @change="radio(iscorrect_01)"
              />
              <label for="a">Correct Answer</label>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card> -->
        <!-- <v-card class="box">
      <v-row justify="center">
        <span v-if="imageSizeFlag2">
          <v-col cols="12" md="12" sm="12">
            <p class="slide">
              Option2 File size should be less than {{ imagesize_new }}KB!
            </p>
          </v-col>
        </span>
        <span v-if="imageTypeFlag2">
          <v-col cols="12" md="12" sm="12">
            <p class="slide">
              Option2 File in
              <span v-for="(img, index) in imagetype_new" :key="index">
                {{ img.imagetype }}
              </span>
              Format!!!
            </p>
          </v-col>
        </span>
      </v-row>
      <v-row>
        <v-col cols="12" sm="2" md="2"> Option 2 </v-col>
        <v-col cols="12" sm="7" md="7">
          <ckeditor v-model="option_02" :config="editorConfig"></ckeditor>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-row>
            <v-col cols="12">
              <v-file-input
                v-model="optfile2"
                prepend-icon="mdi-attachment"
                id="file2"
                label="Choose File"
                show-size
                name="doc"
                @change="validateFile2()"
              ></v-file-input>
            </v-col>
            <v-col cols="12">
              <input
                type="radio"
                class="radiospace"
                id="b"
                value="b"
                v-model="iscorrect_01"
                @change="radio(iscorrect_01)"
              />
              <label for="b">Correct Answer</label>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card> -->
        <v-form id="profile_form" @submit.prevent="submit">
            <v-card class="box" v-for="(input, index) in inputs" in :key="index">
                <v-row dense>
                    <v-col cols="12" sm="1" md="1"></v-col>
                    <!-- <v-col cols="12" sm="2" md="2">
            Option {{ index + 1 }}<br />
            <v-btn
              color="red"
              fab
              small
              dark
              @click="deleteRow(index)"
              class="del"
              v-if="index >= 2"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-col> -->
                    <v-col cols="12" sm="1" md="1">
                        <!-- <ckeditor v-model="input.text" :config="editorConfig"></ckeditor> -->
                        <!-- <v-textarea
              label="Option"
              auto-grow
              v-model="input.text"
              outlined
              rows="3"
            ></v-textarea> -->
                    </v-col>
                    <span>{{ input.text }}</span>
                    <v-col cols="12" md="6" sm="6"></v-col>
                    <v-col cols="12" sm="1" md="1">
                        <v-row dense justify="center">
                            <!-- <br> -->
                            <v-col cols="12">
                                <input type="radio" class="radiospace" @change="radio(index)" v-model="input.value"
                                    :checked="input.value" />
                                <label class="ml-3"><span class="ml-2">Is Correct</span> </label>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card>
            <!-- <div v-show="optionsize <= 3">
        <v-btn class="button" @click="addRow"> Add Option </v-btn>
      </div> -->
        </v-form>
        <v-row justify="center" v-if="this.from != 'QB'">
            <v-btn class="button" @click="showStudents()">Select Students</v-btn>
        </v-row>
        <v-row justify="center" v-if="this.from == 'QB'">
            <v-btn class="button" @click="saveTrueFalse()">Save</v-btn>
        </v-row>

        <div class="text-center">
            <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Please Wait
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
        <v-row justify="center">
            <v-dialog v-model="show_studnts" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar class="toolbar">
                        <v-btn icon dark @click="show_studnts = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>All Students</v-toolbar-title>
                        <v-toolbar-items>
                            <v-btn dark text @click="show_studnts = false">Close</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card class="box">
                        <v-row class="sub-row" justify="center" dense>
                            <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                                <v-data-table :headers="headers_students" :items="learners" :search="search"
                                    class="elevation-1" show-select v-model="selected" item-key="lid"
                                    :items-per-page="-1"></v-data-table>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-row justify="center" v-if="this.from != 'QB'">
                        <v-btn class="button" @click="saveTrueFalse()">Save & Publish</v-btn>
                    </v-row>
                    <v-row justify="center" v-if="this.from == 'QB'">
                        <v-btn class="button" @click="saveTrueFalse()">Save</v-btn>
                    </v-row>

                    <v-row justify="center" dense v-if="this.selected.length > 0">
                        <strong>Total Selected - {{ selected.length }}</strong>
                    </v-row>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- show editor -->
        <!-- <v-row justify="center">
            <v-dialog v-model="show_editor" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar class="toolbar">
                        <v-btn icon dark @click="show_editor = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Text Editor</v-toolbar-title>
                    </v-toolbar>
                    <br />
                    <v-row dense justify="center">
                        <v-col cols="12" sm="7" md="7">
                            <ckeditor v-model="textEditor" :config="editorConfig"></ckeditor>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" v-if="textEditor">
                            <span><v-icon class="icon-quick" title="Copy text" @click="copy(textEditor)">mdi-content-copy</v-icon></span>
                        </v-col>
                    </v-row>
                </v-card>
            </v-dialog>
        </v-row> -->
        <v-dialog v-model="dialog_delete1" persistent max-width="400px">
            <v-card>
                <v-container>
                    <v-col cols="12" xs="12" sm="12" md="12">
                        <p class="slide">
                            File Should Be In -
                            <span v-for="(img, index) in imagetype_new" :key="index">
                                {{ img.imagetype }}
                            </span>
                            Format!!!
                        </p>
                    </v-col>
                    <center>
                        <v-btn class="button" @click="dialog_delete1 = false">OK</v-btn>
                    </center>
                </v-container>
            </v-card>
        </v-dialog>
        <v-dialog v-if="imagesizeflaginputs" v-model="dialog_delete" persistent max-width="400px">
            <v-card>
                <v-container>
                    <span v-if="imagesizeflaginputs">
                        <v-col cols="12" xs="12" sm="12">
                            <p class="slide">
                                File size should be less than {{ imagesize_new }}KB!
                            </p>
                        </v-col>
                    </span>
                    <center>
                        <v-btn class="button" text @click="dialog_delete = false">OK</v-btn>
                    </center>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
    props: {
        chapter: Number,
        sel_crs: Array,
        quiztype: String,
        from: String,
        Level: Number,
    },

    data() {
        return {
            basepath: "",
            headers_students: [
                { text: "Sr. No.", value: "count", sortable: "true" },
                { text: "Student", value: "name" },
            ],
            learners: [],
            show_studnts: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            imagetype_new: null,
            loader: false,

            imagesize_new: null,
            editorConfig: {
                height: "100px",
                extraPlugins: "mathjax",
                mathJaxLib: "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
            },
            qfile: null,
            isapprove: true,
            weightage: 1,
            question: null,
            optionsize: 0,
            inputs: [],
            optionlist: null,
            question_size: null,
            imagesizeflaginputs: false,
            imagesizetypeinputs: false,
            imagesize: null,
            imageSizeFlag: false,
            imageTypeFlag: false,
            imageTypeFlag1: false,
            imageTypeFlag2: false,
            dialog_delete: false,
            dialog_delete1: false,
            dialog_zooimg: false,
            dialog_save: false,
            dialog_save_option: false,
            dialog_upload: false,
            imagesize_new: null,
            imagetype_new: null,
            search: null,
            total_students: [],
            selected: [],
            overlay: false,
            show_editor: false,
            textEditor: "",
            files: [],
            correct_char: [],
            showFlag: false,
            size_flag: false,
            ext_flag: false,
            image_valid: false,
        };
    },
    updated: function () {
        this.$nextTick().then(() => {
            if (window.MathJax) {
                window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log("done"));
            }
        });
    },
    methods: {
        validateFile() {
            let file = this.qfile;
            let file_size = file.size;
            let file_name = this.qfile.name;
            let ext = file_name.split(".").pop();
            const data = {
                type: this.quiztype,
            };
            axios
                .post("/QuizQuestionBank/validatefile", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.imagesize = res.data.imagesize;
                        if (file_size > this.imagesize) {
                            this.imageSizeFlag = true;
                            this.qfile = null;
                        } else {
                            this.imageSizeFlag = false;
                        }
                        this.imagetype = res.data.imagetype;
                        for (var i = 0; i < this.imagetype.length; i++) {
                            if (ext == this.imagetype[i].imagetype) {
                                this.imageTypeFlag = false;
                                return;
                            }
                        }
                        for (var i = 0; i < this.imagetype.length; i++) {
                            if (ext != this.imagetype[i].imagetype) {
                                this.imageTypeFlag = true;
                                this.qfile = null;
                                return;
                            }
                        }
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                .catch((error) => {
                    this.onerror(error);
                    window.console.log(error);

                    this.showSnackbar("#b71c1c", "Something went wrong !!!");
                });
        },
        validateFileOptions(filename, index) {
            let file1 = filename;
            let invalid = "";
            let file_size1 = file1.size;
            let file_name1 = filename.name;
            let ext1 = file_name1.split(".").pop();
            const data = {
                type: this.quiztype,
            };
            axios
                .post("/QuizQuestionBank/validatefile", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        console.log(res.data.imagesize);
                        this.imagesize = res.data.imagesize;
                        if (file_size1 > this.imagesize) {
                            this.imagesizeflaginputs = true;
                            this.dialog_delete = true;
                            this.inputs[index].file = null;
                        } else {
                            this.imagesizeflaginputs = false;
                            this.dialog_delete = false;
                        }
                        console.log(res.data.imagetype);
                        this.imagetype = res.data.imagetype;

                        for (var i = 0; i < this.imagetype.length; i++) {
                            if (ext1 == this.imagetype[i].imagetype) {
                                this.imagesizetypeinputs = false;
                                this.dialog_delete1 = false;
                                return;
                            } else {
                                this.imagesizetypeinputs = true;
                                this.dialog_delete1 = true;

                                invalid = "invalidfile";
                            }
                        }
                        if (invalid == "invalidfile") {
                            this.inputs[index].file = null;
                        }
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                .catch((error) => {
                    this.onerror(error);
                    window.console.log(error);

                    this.showSnackbar("#b71c1c", "Something went wrong !!!");
                });
        },
        showEditor() {
            // this.show_editor = true;
            let routeData = this.$router.resolve({
                name: "editor",
            });
            window.open(routeData.href, "_blank");
        },
        copy(text) {
            navigator.clipboard.writeText(text);
            //   alert("Text copied to clipboard!!!");
            this.showSnackbar("#4caf50", "Text copied to clipboard!!!");
        },
        reset() {
            (this.weightage = 1), (this.question = null), (this.qfile = null), (this.inputs = []);
        },
        showStudents() {
            var iscorrect = false;
            for (let i = 0; i < this.inputs.length; i++) {
                if (this.inputs[i].value == null || this.inputs[i].value == true) {
                    this.inputs[i].value = true;
                    iscorrect = true;
                }
            }
            if (iscorrect == false) {
                this.showSnackbar("#b71c1c", "Please select correct option..."); // show snackbar
                return;
            }
            if (this.imagesizeflaginputs) {
                this.showSnackbar("#b71c1c", "Please check file size!!!"); // show snackbar
                return false;
            }
            if (this.imagesizetypeinputs) {
                this.showSnackbar("#b71c1c", "Please check file extension!!!"); // show snackbar
                return false;
            }
            this.show_studnts = true;
            this.markAllSelected();
        },
        markAllSelected() {
            this.selected = [];
            for (let i = 0; i < this.learners.length; i++) {
                this.selected.push(this.learners[i]);
            }
        },
        saveTrueFalse() {
            this.total_students = [];
            var form = document.getElementById("profile_form");
            let formData = new FormData(form);
            if ((this.qfile == null && this.question == "") || (this.qfile == null && this.question == null)) {
                this.showSnackbar("#b71c1c", "Please Add The Question !!!"); // show snackbar
                return;
            }

            if (this.imagesizeflaginputs) {
                this.showSnackbar("#b71c1c", "Please check file size!!!"); // show snackbar
                return false;
            }
            if (this.imagesizetypeinputs) {
                this.showSnackbar("#b71c1c", "Please check file extension!!!"); // show snackbar
                return false;
            }
            var iscorrect = false;

            for (let i = 0; i < this.inputs.length; i++) {
                if (this.inputs[i].value == null || this.inputs[i].value == true) {
                    this.inputs[i].value = true;
                    iscorrect = true;
                }
            }
            if (iscorrect == false) {
                this.showSnackbar("#b71c1c", "Please select correct option..."); // show snackbar
                return;
            }

            var asc = 64;
            var correct;
            for (let i = 0; i < this.inputs.length; i++) {
                asc += 1;
                if (this.inputs[i].value == true) {
                    correct = asc;
                }
                formData.append("opt_id", i);
                formData.append("optiscorrect", this.inputs[i].value);
                formData.append("opttext", this.inputs[i].text);
                let file = this.inputs[i].file;

                if ((this.inputs[i].text == "" && this.inputs[i].file == "") || (this.inputs[i].text == null && this.inputs[i].file == null)) {
                    this.showSnackbar("#b71c1c", "Either option text or option image file is compulsory please add..."); // show snackbar
                    return;
                }
            }
            formData.append("correct_char", correct);
            formData.append("qfile", this.qfile);
            formData.append("weightage", this.weightage);
            formData.append("question", this.question);
            formData.append("isapprove", this.isapprove);
            formData.append("ch_id", this.chapter);
            formData.append("Level_id", this.Level);
            formData.append("from", this.from);
            if (this.from == "QB") {
                formData.append("crs_id", this.sel_crs);
            } else {
                formData.append("crs_id", this.sel_crs[0].coff_id);
                for (let i = 0; i < this.sel_crs.length; i++) {
                    formData.append("coi_id", this.sel_crs[i].coi_id);
                }
                for (var i = 0; i < this.selected.length; i++) {
                    this.total_students.push(this.selected[i].lid);
                    formData.append("total_students", this.selected[i].lid);
                }
                if (this.total_students.length <= 0) {
                    this.showSnackbar("#b71c1c", "Please select Students!"); // show snackbar
                }
            }
            formData.append("type", this.quiztype);
            this.dialog_upload = true;
            this.overlay = true;
            this.loader = true;
            //return;
            axios
                .post("/LiveClass/saveTrueFalse", formData, {})
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Saved And Published Successfully...");
                        this.dialog_upload = false;
                        this.reset();
                        this.addFirstTwoRows();
                        (this.total_students = []), (this.show_studnts = false);
                        this.overlay = false;
                        this.loader = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong !!!");
                    this.dialog_upload = false;
                    this.loader = false;
                })
                .finally(() => {
                    this.isapprove = true;
                    this.overlay = false;
                    this.loader = false;
                });
        },
        nextChar(c) {
            return String.fromCharCode(c.charCodeAt(0) + 1);
        },
        radio(index) {
            for (let i = 0; i < this.inputs.length; i++) {
                if (i == index) {
                    if (this.inputs[i].inputs == false) {
                        this.inputs[i].value = true;
                    }
                } else {
                    this.inputs[i].value = false;
                }
            }
        },
        addFirstTwoRows() {
            this.inputs.push({
                value: "",
                text: "True",
                file: null,
            });
            this.optionsize++;

            this.inputs.push({
                value: "",
                text: "False",
                file: null,
            });
            this.optionsize++;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        getQuestionBank() {
            let crs_id = "";
            if (this.from == "QB") {
                crs_id = this.sel_crs;
            } else {
                crs_id = this.sel_crs[0].coff_id;
            }
            const data = {
                crs_id: crs_id,
                ch_id: this.chapter,
                type: this.quiztype,
                Level_id: this.Level,
            };
            axios
                .post("/QuizQuestionBank/getQuestionBank", data)
                .then((res) => {
                    this.question_size = res.data.question_size;
                    this.imagesize_new = res.data.imagesize / 1000;
                    this.imagetype_new = res.data.imagetype;
                })
                .catch((error) => {
                    window.console.log(error);

                    this.showSnackbar("#b71c1c", "Something went wrong !!!");
                })
                .finally(() => { });
        },



    },
    mounted() {
        // console.log("sel_crs LiveMCQ", this.sel_crs);
        this.getQuestionBank();
        this.addFirstTwoRows();
        this.learners = JSON.parse(localStorage.getItem("live-session-students"));
        this.basepath = localStorage.getItem("awspath");
    },
};
</script>
<style scoped>
.slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
}
</style>
